/* eslint no-console: "off", no-use-before-define: ["error", { "variables": false }] */
import { mapState } from 'vuex';
import webSocket from '@/common/webSocket';

const OnlineUsersMixin = {
  data() {
    return {
      stompClientForGame: null,
      connectionTimerGame: null,
      gameSubscription: null,
    };
  },
  beforeDestroy() {
    if (this.gameSubscription) {
      this.gameSubscription.unsubscribe();
    }
  },
  methods: {
    initGameDataMixin() {
      this.stompClientForGame = webSocket.getGameStompClient();
      if (this.stompClientForGame === null) {
        this.stompClientForGame = webSocket.createNewStompClient('/gameData');
      }

      const stompSuccess = (frame) => {
        clearTimeout(this.connectionTimerGame);
        // eslint-disable-next-line
        console.log(`In Home component: ${frame}`);
        // eslint-disable-next-line
        console.log(`Subscribing to channel: /topic/gameFound/${this.userDetails.msisdn}`);
        // eslint-disable-next-line
        this.gameSubscription = this.stompClientForGame.subscribe(`/topic/gameFound/${this.userDetails.msisdn}`, () => {
          // eslint-disable-next-line
          console.log('[Home] Inside gameFound channel NO response');
        }, (errorResponse) => { // error callback
          console.log(errorResponse);
        });
      };
      const stompFailure = (error) => {
        // eslint-disable-next-line
        console.log(error);
        clearTimeout(this.connectionTimerGame);
        this.connectionTimerGame = setTimeout(() => {
          this.stompClientForGame = webSocket.createNewStompClient('/gameData');
          connect();
        }, 3000);
      };

      const connect = (() => {
        if (!this.stompClientForGame.connected) {
          this.stompClientForGame.connect({ Authorization: this.jwtInVuex }, stompSuccess, stompFailure);
        } else {
          stompSuccess();
        }
      });
      connect();
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('common', [
      'userDetails',
    ]),
  },
};

export default OnlineUsersMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/game/gameClient.js